export default [
    {
        id: 1,
        name_ca: 'Edificació entre mitgeres',
        name_en: 'Terraced buildings',
        name_es: 'Edificación entre medianeras'
    },
    {
        id: 2,
        name_ca: 'Edificació aïllada',
        name_en: 'Detached buildings',
        name_es: 'Edificación aislada'
    },
    {
        id: 3,
        name_ca: 'Edificació segons volumetria específica',
        name_en: 'Buildings according to specific volumetry',
        name_es: 'Edificación según volumetría específica'
    },
    {
        id: 4,
        name_ca: 'Edificació seguint alineació de vial',
        name_en: 'Buildings following road alignment',
        name_es: 'Edificación siguiendo alineación de vial'
    }
]



// WEBPACK FOOTER //
// ./src/options/homogeneity_features.js